import styled from '@emotion/styled';

export const Description = styled.p`
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 20px;
`;

export const TopBanner = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
`;
